// extracted by mini-css-extract-plugin
export default {"root":"bubbles-module--root--68cca"};